export default {
  buyRow1: 'JWI Industrial Software lets you efficiently rebuild your technology stack; prioritizing the digital',
  buyRow2: 'capabilities you need to get started, running new applications concurrently with your existing systems,',
  buyRow3: 'and easily deploying new improvements as needed.',
  buyRow4: 'SIGN UP FOR A',
  buyRow5: 'FREE EVALUATION',
  buyRow6: 'Experience and test the digital transformation',
  buyRow7: 'capabilities of JWI Industrial Software in an',
  buyRow8: 'interactive, non-production environment.',
  buyRow9: 'Create your account and you can experience the first truly real-time digital thread.',
  buyRow10: 'See how JWI improves collaboration and helps you make faster, better decisions.',
  buyRow11: 'WHAT IS INCLUDED IN THE FREE TRIAL?',
  buyRow12: 'Digital PLM',
  buyRow13: 'Digital PQM',
  buyRow14: 'Device Mate',
  buyRow15: '',
  buyRow16: '',
  buyRow17: 'SIGN UP',
  buyRow18: 'Company Name',
  buyRow19: 'Name',
  buyRow20: 'Mobile',
  buyRow21: 'Auth Code',
  buyRow22: 'Get Auth Code',
  buyRow23: 'I agree JWI SoftwareTerms of service、Privacy policy',
  buyRow24: 'JWI Industry Cloud'
}
